import React from 'react';

const Projects = (props) => {
    return (
        <section id="portfolio" className="no-pad-bottom projects-gallery">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 text-center">
                        <h1>{props.data.title}</h1>
                        <p className="lead">{props.data.description}</p>
                    </div>
                </div>                  
            </div>        
            <div className="projects-wrapper clearfix">                 
                <div className="projects-container">

                    {props.data.list ? 
                        (
                            props.data.list.map((item, itemIndex) => {
                                return (
                                    <div key={itemIndex} className={`no-pad project development image-holder ${itemIndex < 2 ? 'col-md-6 col-sm-12' : 'col-md-4 col-sm-6'}`}>
                                        <div className="background-image-holder">
                                            <img className="background-image" alt="" src={`${item.image}`} />
                                        </div>
                                        <div className="hover-state">
                                            <div className="align-vertical">
                                                <h1 className="text-white"><strong>{item.title}</strong></h1>
                                                <p className="text-white">{item.description}</p>
                                                <a target="_blank" rel="noopener noreferrer" href={`${item.link}`} className="btn btn-primary btn-white">See Project</a>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )
                    : null
                    }
                                   
                </div>                  
            </div>              
        </section>
    )
}

export default Projects;